import React from "react";

import { Box, InputLabel, MenuItem, FormControl } from "@mui/material";

import Select, { SelectChangeEvent } from "@mui/material/Select";

const TableFilter = ({
	onChange,
	filterVal,
	filterLabel,
	options
}: {
	onChange: (val: string) => void;
	filterVal: string;
	filterLabel: string;
	options: { label: string; value: string }[];
}) => {
	const handleChange = (event: SelectChangeEvent) => {
		onChange(event.target.value as string);
	};
	return (
		<Box sx={{ minWidth: 120 }}>
			<FormControl sx={{ m: 1, minWidth: 120 }} size="small">
				<InputLabel id={`filter-${filterLabel}`}>{filterLabel}</InputLabel>
				<Select
					labelId={`filter-${filterLabel}`}
					id={`filter-${filterLabel}-select`}
					value={filterVal}
					label={filterLabel}
					onChange={handleChange}
				>
					{options.map(option => (
						<MenuItem key={option.label} value={option.value}>
							{option.label}
						</MenuItem>
					))}
				</Select>
			</FormControl>
		</Box>
	);
};

export default TableFilter;
